import React from "react";

export const Phone = (props) => {
  const { field, fieldId } = props;
  const { placeholder, label, isRequired, className, id, labelPlacement, layoutGridColumnSpan, description } = field;
  const columnClass = `col-span-${layoutGridColumnSpan}`;
  // Gravity Form field ID ~ name.
  const gfName = `input_${id}`;
  return (
    <div
      className={`${className ? ` ${className}` : ""}${isRequired ? " required" : ""} ${labelPlacement} ${columnClass}`}
    >
      <label htmlFor={fieldId}>{label}</label>
      <input
        name={gfName}
        id={fieldId}
        placeholder={placeholder}
        required={!!isRequired}
        type="phone"
        pattern="^[0-9]+$"
      />
      {description && (<p className="description">{description}</p>)}
    </div>
  );
};
